import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Outlet, Route, Routes } from 'react-router-dom'

import { Header } from '../components/Header'
import { HeaderMobile } from '../components/HeaderMobile'
import { Loader } from '../components/Loader'
import { Sidebar } from '../components/SideBar'
import { AllLinks } from '../pages/AllLinks'
import { Analytics } from '../pages/Analytics'
import { Design } from '../pages/Design'
import { EnterPassword } from '../pages/EnterPassword'
import { Icons } from '../pages/Icons'
import { LinkPage } from '../pages/Link'
import { Login } from '../pages/Login'
import { MyAccount } from '../pages/MyAccount'
import { MyBilling } from '../pages/MyBilling'
import { Pricing } from '../pages/Pricing'
import { ResetPassword } from '../pages/ResetPassword'
import { Settings } from '../pages/Settings'
import { SignUp } from '../pages/Signup'
import { UpdatePassword } from '../pages/UpdatePassword'
import { tokenService } from '../services/token'
import { RootState, useAppDispatch } from '../store'
import { getCurrentUser } from '../store/actions/authActions'
import { updateToken } from '../store/slice/auth'
import { PrivateRoute } from './PrivateRoute'
import { RestrictedRoute } from './RestrictedRoute'
import NotFound from '../pages/NotFound'

const AppRoutesWithHeader = () => {
  return (
    <div className="relative">
      <div className="block sm:hidden">
        <HeaderMobile />
      </div>
      <div className="hidden sm:block">
        <Header />
      </div>
      <Sidebar />
      <Outlet />
    </div>
  )
}

const AppRoutes = () => {
  const { loading: userLoading } = useSelector(
    (state: RootState) => state.userReducer,
  )
  const [loading, setLoading] = useState(true)
  const dispatch = useAppDispatch()

  // Retrieve token from local storage and get current user.
  useEffect(() => {
    const token = tokenService.getToken()
    if(token) {
      dispatch(updateToken(token || null))
      dispatch(getCurrentUser())
    }
    setLoading(false)
  }, [])

  // if (loading || userLoading)
  //   return (
  //     <div className="h-screen w-screen">
  //       <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
  //         <Loader />
  //       </div>
  //     </div>
  //   )

  return (
    <Routes>
      <Route path="/" element={<RestrictedRoute component={Login} />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/update-password" element={<UpdatePassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/enter-password" element={<EnterPassword />} />
      <Route element={<PrivateRoute component={AppRoutesWithHeader} />}>
        <Route path="/links" element={<PrivateRoute component={AllLinks} />} />
        <Route path="/icons" element={<PrivateRoute component={Icons} />} />
        <Route path="/design" element={<PrivateRoute component={Design} />} />
        <Route
          path="/analytics"
          element={<PrivateRoute component={Analytics} />}
        />
        <Route
          path="/settings"
          element={<PrivateRoute component={Settings} />}
        />
        <Route path="/link" element={<PrivateRoute component={LinkPage} />} />
        <Route
          path="/account"
          element={<PrivateRoute component={MyAccount} />}
        />
        <Route
          path="/billing"
          element={<PrivateRoute component={MyBilling} />}
        />
      </Route>
      <Route path="/pricing" element={<PrivateRoute component={Pricing} />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes
